import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useEffect, useState } from 'react';
import { EtapaSetup } from '../models/ciclo';
import { EVIDENCIA_PADRAO_ETAPA_SETUP } from '../utils/labels';

interface ModalCadastroSetupPendenciaProps {
  etapa: EtapaSetup | null;
  onFechar: () => void;
  onResolver: (etapaId: number, evidenciaDescricao: string) => void;
  /** Sobrescreve o texto sugerido padrão — usado quando já existe dado real (grupo/usuário
   * cadastrado) e a evidência pode ser gerada a partir disso, em vez do texto genérico fixo. */
  evidenciaSugerida?: string;
}

// Resolução de etapa do Setup do Maestro — o backend (MAESTRO-RN-18) só exige uma evidência
// textual não vazia para concluir uma etapa (PUT /api/maestro/setup/etapas/{id}/concluir); não há
// formulário de negócio próprio por tipo de etapa (cadastro de usuário/feriado/aprovador é feito
// nas telas reais desses domínios, fora do Maestro). Sem esse texto, o backend rejeita a conclusão.
// O campo já vem com um texto sugerido (mesmo padrão do onboarding do Workflow SOX — sugestão
// editável, nunca enviada sem o usuário poder revisar/alterar antes de confirmar).
const ModalCadastroSetupPendencia: React.FC<ModalCadastroSetupPendenciaProps> = ({ etapa, onFechar, onResolver, evidenciaSugerida }) => {
  const [evidenciaDescricao, setEvidenciaDescricao] = useState('');

  useEffect(() => {
    setEvidenciaDescricao(etapa ? (evidenciaSugerida ?? EVIDENCIA_PADRAO_ETAPA_SETUP[etapa.tipo] ?? '') : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [etapa]);

  if (!etapa) return null;

  const salvar = () => {
    if (!evidenciaDescricao.trim()) return;
    onResolver(etapa.id, evidenciaDescricao.trim());
    onFechar();
  };

  return (
    <Dialog open={!!etapa} onClose={onFechar} maxWidth='sm' fullWidth PaperProps={{ className: 'mc-dialog' }}>
      <DialogTitle>Concluir etapa — {etapa.titulo}</DialogTitle>
      <DialogContent>
        <p className='mc-texto-neutro'>{etapa.descricao}</p>

        {etapa.pendencias.length > 0 && (
          <ul className='mc-setup-item__pendencias'>
            {etapa.pendencias.map((p, i) => (
              <li key={i} className={p.bloqueante ? 'is-bloqueante' : ''}>
                <i className={`bi bi-${p.bloqueante ? 'exclamation-octagon-fill' : 'info-circle'}`} /> {p.descricao}
              </li>
            ))}
          </ul>
        )}

        <label className='mc-campo'>
          Evidência de resolução <small className='mc-texto-neutro'>(sugestão pré-preenchida — edite se necessário)</small>
          <textarea
            rows={4}
            value={evidenciaDescricao}
            onChange={e => setEvidenciaDescricao(e.target.value)}
            placeholder='Descreva como a pendência foi resolvida (ex.: link do cadastro, protocolo, referência do que foi ajustado)...'
          />
        </label>
      </DialogContent>
      <DialogActions>
        <button type='button' className='mc-btn mc-btn--secondary' onClick={onFechar}>Cancelar</button>
        <button type='button' className='mc-btn mc-btn--primary' disabled={!evidenciaDescricao.trim()} onClick={salvar}>
          Concluir etapa
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCadastroSetupPendencia;
